<template>
  <el-dialog
    title="加密模式設定"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item
        label="加密"
        :label-width="formLabelWidth"
        prop="isEncrypt"
      >
      <el-switch
        v-model="form.isEncrypt"
        active-text="啟用"
        inactive-text="關閉">
        </el-switch>
      </el-form-item>
      <el-form-item
        label="失效日模式"
        :label-width="formLabelWidth"
        prop="encryptExpiredMode"
      >
      <el-switch
        :disabled="!form.isEncrypt"
        v-model="form.encryptExpiredMode"
        active-value="absolute"
        inactive-value="relative"
        active-text="指定日期"
        inactive-text="相對日期">
        </el-switch>
      </el-form-item>
      <el-form-item
        v-if="form.encryptExpiredMode=='absolute'"
        label="失效日"
        :label-width="formLabelWidth"
        prop="endDate"
      >
       <el-date-picker
       :disabled="!form.isEncrypt"
       v-model="form.endDate"
               :picker-options="pickerOptions"
      type="date"
      value-format="timestamp"
      placeholder="指定失效日">
        </el-date-picker>
      </el-form-item>
      <el-form-item
      v-if="form.encryptExpiredMode=='relative'"
        label="下載後"
        :label-width="formLabelWidth"
        prop="endDate"
      >
        <el-input-number v-model="form.endDateAmount" :min="1" :max="999">
        </el-input-number>
            <el-select v-model="form.endDateUnit"  placeholder="單位">
                <el-option label="日" value="days"></el-option>
    </el-select>失效
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
export default {
 model: {
    prop: "visible",
    event: "toggleVisible",
 },
 data() {
    return {
        pickerOptions: {
        disabledDate(time) {
                return time.getTime() > 4102358400000
            },
        },
      isLoading: false,
      formLabelWidth: "100px",
      form: {
          isEncrypt: false,
          encryptExpiredMode: 'absolute',
          endDate: null,
          endDateAmount: 7,
          endDateUnit: 'days'
      },
      rules:{}
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedRows: {
      type: Array,
      default: null,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  methods:{
     submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            this.isLoading = true;
            if(this.form.isEncrypt && this.form.encryptExpiredMode == 'absolute' && !this.form.endDate){
                this.form.endDate = 4102358400000;
            }
            const promises = this.selectedRows.map(row => API.asset.update({id:row.id, ...this.form}));
            Promise.all(promises).finally(() => {
                this.isLoading = false;
                this.innerVisible = false;
                this.$store.dispatch("asset/getAssetContent", null);
            });
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style>

</style>